const CheckBoxHandle = (e, selectedValues, setSelectedValues) => {
    const { value, checked } = e.target;
    if (checked) {
      setSelectedValues([...selectedValues, value]);
    } else {
      setSelectedValues(selectedValues.filter((data) => data !== value));
    }
  };
  export default CheckBoxHandle;